/**
 * Must stay in sync with PERM_ACCESS / PERM_ADMIN in src/auth.py.
 *
 * These are strings in the shared skulytics_accuracy.users.permissions array,
 * so they are namespaced by tool. `*` in a user's permissions satisfies both.
 */
export const PERMISSIONS = {
  /** loads the dashboard at all */
  ACCESS: 'skuly-proxy.access',
  /** the destructive surface: teardown, account deletion, credential writes */
  ADMIN: 'skuly-proxy.admin',
} as const;

export const ALL_ACCESS = '*';
